import React, { createContext, useContext, useState } from 'react';

const validThemes = ['brand', 'light', 'light-alt'];

/* ========================================================================= */
/* Context(s) */
/* ========================================================================= */

const ThemeContext = createContext({
    setTheme: (_ = '') => {},
    theme: '',
    validThemes: []
});

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const useTheme = () => {
    const context = useContext(ThemeContext);

    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider.');
    }

    return context;
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const ThemeProvider = ({ children }) => {
    const [ theme, setThemeInternal ] = useState('light');

    const setTheme = (value = '') => {
        if (validThemes.includes(value)) {
            setThemeInternal(value);
        }
    };

    return (
        <ThemeContext.Provider value={{
            setTheme,
            theme,
            validThemes
        }}>
            {children}
        </ThemeContext.Provider>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ThemeContext.displayName = 'ThemeContext';

export {
    ThemeProvider,
    useTheme,
    validThemes
};
